
import Vue from 'vue'
import { AttachmentInterface } from '@/types/interfaces'
import VuePictureSwipe from 'vue-picture-swipe'

export default Vue.extend({
  name: "PostGallery",
  props: {
    attachments: {
      type: Array,
      default: []
    }
  },
  data(){
    return {}
  },
  computed: {
    amountClass(){
      return this.attachments.length == 1 ? "article__gallery--1"
        : this.attachments.length == 2 ? "article__gallery--2"
        : this.attachments.length == 3 ? "article__gallery--3"
        : "article__gallery--3plus"
    }
  },
  methods: {
    formaAttachedtImages(attachments: Array<AttachmentInterface>){
      return attachments.map(attachment => {
        return {
          src: attachment.preview,
          thumbnail: attachment.preview,
          w: attachment.metadata?.width || 600,
          h: attachment.metadata?.height || 400
        }
      })
    }
  },
  components: {
    VuePictureSwipe
  }
})
